var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isToggledRepsHistory
    ? _c(
        "div",
        [
          _vm.sections.length == 0
            ? _c("div", { staticClass: "reps_card" }, [_vm._m(0)])
            : _vm._l(_vm.sections, function(item, index) {
                return _c("div", { key: index, staticClass: "reps_card" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-11" }, [
                      _vm._v(_vm._s(item.text))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: {
                        "font-style": "italic",
                        "font-size": "12px"
                      }
                    },
                    [
                      _c("div", { staticClass: "col-12 text-align-right" }, [
                        _vm._v(
                          "Updated by: " +
                            _vm._s(item.created_by) +
                            " on " +
                            _vm._s(_vm._f("formatDate")(item.created_at))
                        )
                      ])
                    ]
                  )
                ])
              })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-align-center" }, [
        _vm._v("No data found!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48cf859a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cf859a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/section_history.vue
// module id = null
// module chunks = 